import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { getUserData, checkAdminUser } from '../services/fetchreport'
import { updateuser, updateAdmin, updateIsInternal } from '../reduxstore/actions'
import LoaderComponent from '../loaderComp/LoaderComponent'
import NoUserFoundComponent from '../NoUserFoundComponent/NoUserFoundComponent'
import LockIcon from '@mui/icons-material/Lock'
import { Link } from 'react-router-dom'

interface UserInfo {
  customerName?: string
  userName?: string
  userType?: string
  [key: string]: any
}

interface PageheaderProps {
  onLogout?: () => void
  updateUser: (users: UserInfo[]) => void
  updateIsAdmin: (isAdmin: boolean) => void
  updateIsInternal: (isInternal: boolean) => void
}

function Pageheader (props: PageheaderProps): React.JSX.Element {
  const { onLogout } = props
  const [userData, setUser] = useState<UserInfo[]>([])
  const [userAvail, setUserAvail] = useState<boolean | undefined>()

  const style: React.CSSProperties = {
    borderBottom: '1px solid #ccc',
    position: 'fixed',
    width: '100%',
    top: '0',
    zIndex: 100,
    boxShadow: '0 -1px 4px hsl(0deg 0% 60% / 50%)',
    backgroundColor: '#fff'
  }
  const headerStyle: React.CSSProperties = {
    margin: '0 5% 0 0',
    fontFamily: 'Georgia Bold,Georgia',
    fontSize: 35
  }

  const organization = async () => {
    try {
      const userResponse = await getUserData()
      if (userResponse.ok === false || userResponse.status === 204 || userResponse.status === 404 || userResponse.status === 400) {
        console.log('service error')
        setUserAvail(false)
        throw new Error('error in user data fetch')
      } else {
        let internalUser = false
        if ((userResponse[0]?.userType?.indexOf('Internal') > -1) || (userResponse[0]?.userType?.indexOf('er.internal') > -1) || (userResponse[0]?.userType?.indexOf('internal') > -1)) {
          internalUser = true
          props.updateIsInternal(internalUser)
        }
        setUserAvail(true)
        const set = new Set<string>()
        const uniqueUser = userResponse.filter((data: UserInfo) => {
          const duplicate = set.has(data.customerName || '')
          set.add(data.customerName || '')
          return !duplicate
        })
        setUser(uniqueUser)
        props.updateUser(uniqueUser)
        checkIsAdmin(uniqueUser)
      }
    } catch (e) {
      console.log('error in fetch user data', e)
    }
  }

  const checkIsAdmin = async (uniqueUser: UserInfo[]) => {
    const isAdmin = await checkAdminUser(uniqueUser)

    if (isAdmin) {
      props.updateIsAdmin(isAdmin)
    }
  }

  useEffect(() => {
    organization()
  }, [])
  return (
    <div style={style}>
      {userAvail != null
        ? userData.length > 0
          ? <>
              <header className={'main-header'} role="banner">
                <div>
                <img className={'metlife-logo'} alt="Metlife" title="Metlife" src="https://content.online.metlife.com/content/dam/metlifecom/global/icons-header/metlife_logo.png" />
                <span className='divider'>{'|'}</span>
                <span className="customer-text">{userData[0]?.customerName}</span>
                </div>
                <div>
                  <span className="welcome-text">Welcome</span>
                  <span className="user-text">{userData[0]?.userName}</span>
                  <LockIcon onClick={onLogout} style={{ cursor: 'pointer' }} />
                </div>
              </header>
              <div className="navbar">
                <Link to="/">REPORT CENTER</Link>
                {/* <a className="active" href="." onClick={(e) => e.preventDefault()}><i className="fa fa-fw fa-REPORT CENTER" />REPORT CENTER</a> */}
                </div>
              {/* <footer className={'footer'}>
              </footer> */}
            </>
          : <div>
              <header className={'main-header'} role="banner">
                <img className={'metlife-logo'} alt="Metlife" title="Metlife" src="https://content.online.metlife.com/content/dam/metlifecom/global/icons-header/metlife_logo.png" />
                <h1 style={headerStyle}>Reports</h1>
                <div>
                  <span className="welcome-text">Welcome</span>
                </div>
              </header>
              <NoUserFoundComponent />
            </div>
        : <LoaderComponent/>
      }
    </div>
  )
}

const mapDispatchToProps = (dispatch: any) => ({
  updateUser: (user: UserInfo[]) => dispatch(updateuser(user)),
  updateIsAdmin: (admin: boolean) => dispatch(updateAdmin(admin)),
  updateIsInternal: (checkInternal: boolean) => dispatch(updateIsInternal(checkInternal))
})

export default connect(null, mapDispatchToProps)(Pageheader)
